module.exports = __webpack_public_path__ + "static/media/_L7-Matlab.76fefac5.svg";